export const ratingToColor = {
    'very-high': 'red11',
    high: 'amber11',
    low: undefined
};
export const getSlippageRating = (slippage) => {
    const slippageNumber = parseFloat(slippage);
    if (slippageNumber >= 40)
        return 'very-high';
    if (slippageNumber >= 6)
        return 'high';
    return 'low';
};
//# sourceMappingURL=slippage.js.map